import React, { useState } from "react";
import { Link } from "react-router-dom";

function Index() {


    return (
        <>


            {/* <!-- Spinner Start --> */}
            {/* <div id="spinner" class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-primary" style={{width: '3rem', height: '3rem', role:'status'}}>
            <span class="sr-only">Loading...</span>
        </div>
    </div> */}
            {/* <!-- Spinner End --> */}


            {/* <!-- Topbar Start --> */}
            <div class="container-fluid bg-dark p-0">
                <div class="row gx-0 d-none d-lg-flex">
                    <div class="col-lg-7 px-5 text-start">
                        <div class="h-100 d-inline-flex align-items-center me-4">
                            <small class="fa fa-map-marker-alt text-primary me-2"></small>
                            <small>Opposite Safron Landmark, Beed Bypass, Aurangabad-431010</small>
                        </div>
                        <div class="h-100 d-inline-flex align-items-center">
                            <small class="far fa-clock text-primary me-2"></small>
                            <small>Mon - Fri : 09.00 AM - 09.00 PM</small>
                        </div>
                    </div>
                    <div class="col-lg-5 px-5 text-end">
                        <div class="h-100 d-inline-flex align-items-center me-4">
                            <small class="fa fa-phone-alt text-primary me-2"></small>
                            <small>7798121291</small>
                        </div>
                        <div class="h-100 d-inline-flex align-items-center mx-n2">
                            <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-facebook-f"></i></a>
                            <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-twitter"></i></a>
                            <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-linkedin-in"></i></a>
                            <a class="btn btn-square btn-link rounded-0" href=""><i class="fab fa-instagram"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Topbar End --> */}


            {/* <!-- Navbar Start --> */}
            <nav class="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0">
                <a href="index.html" class="navbar-brand d-flex align-items-center border-end px-4 px-lg-5">
                    <img src="img/logo.jpeg" width="100" />
                </a>
                <button type="button" class="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarCollapse">
                    <div class="navbar-nav ms-auto p-4 p-lg-0">
                        <Link to="/"><a href="/" class="nav-item nav-link active">Home</a></Link>
                        <Link to="/about"> <a href="/about" class="nav-item nav-link">About</a></Link>
                        <div class="nav-item dropdown">
                            <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">Service</a>
                            <div class="dropdown-menu bg-light m-0">
                                <Link to="/enginerringServices"> <a href="/enginerringServices" class="dropdown-item">Engineering and Consultancy Service</a></Link>
                                <Link to="/fireHydrant"><a href="/fireHydrant" class="dropdown-item">Fire Hydrant System</a></Link>
                                <Link to="/firesprinkler"><a href="/firesprinkler" class="dropdown-item">Fire Sprinkler System</a></Link>
                                <Link to="/fireAlarm"><a href="/fireAlarm" class="dropdown-item">Fire Alarm and Detection System</a></Link>
                                <Link to="/publicAddress"><a href="/publicAddress" class="dropdown-item">Public Address System</a></Link>
                                <Link to="/accessControl"><a href="/accessControl" class="dropdown-item">Access Control System</a></Link>
                                <Link to="/transformerProtection"><a href="/transformerProtection" class="dropdown-item">Transformer Protection System</a></Link>
                                <Link to="/integratedSecurity"><a href="/integratedSecurity" class="dropdown-item">Integrated Security System</a></Link>
                            </div>
                        </div>
                        <Link to="/contact"> <a href="/contact" class="nav-item nav-link">Contact</a></Link>
                        <button className="download">
                        <a href="pdf/SSFire.pdf" download>Download Brochure </a>
                        </button>
                    </div>
                </div>
            </nav>
            {/* <!-- Navbar End --> */}


            {/* <!-- Carousel Start --> */}
            {/* <!-- Carousel --> */}
            <div id="demo" class="carousel slide" data-bs-ride="carousel">

                {/* <!-- Indicators/dots --> */}
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#demo" data-bs-slide-to="0" class="active"></button>
                    <button type="button" data-bs-target="#demo" data-bs-slide-to="1"></button>
                    <button type="button" data-bs-target="#demo" data-bs-slide-to="2"></button>
                </div>

                {/* <!-- The slideshow/carousel --> */}
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <img src="img/banner3.jpg" alt="Los Angeles" class="d-block" style={{ width: '100%', height: '600px' }} />
                        <div class="carousel-caption">
                            <h1 style={{color:'black',fontSize:'55px',fontWeight:'900'}}>SS FIRE ENGINEERS</h1>
                            <p style={{color:'black',fontWeight:'900'}}>Committed professionals at your service</p>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <img src="img/banner2.png" alt="Chicago" class="d-block" style={{ width: '100%', height: '600px' }} />
                    </div>
                    <div class="carousel-item">
                        <img src="img/banner1.jpg" alt="New York" class="d-block" style={{ width: '100%', height: '600px' }} />
                    </div>
                </div>

                {/* <!-- Left and right controls/icons --> */}
                <button class="carousel-control-prev" type="button" data-bs-target="#demo" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon"></span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#demo" data-bs-slide="next">
                    <span class="carousel-control-next-icon"></span>
                </button>
            </div>
            {/* <!-- Carousel End --> */}



            {/* <!-- About Start --> */}
            <div class="container-fluid bg-light overflow-hidden my-5 px-lg-0">
                <div class="container about px-lg-0">
                    <div class="row g-0 mx-lg-0">
                        <div class="col-lg-6 ps-lg-0 wow fadeIn" data-wow-delay="0.1s" style={{ minHeight: '400px' }}>
                            <div class="position-relative h-100">
                                <img class="position-absolute img-fluid w-100 h-100" src="img/abt.png" style={{ objectFit: 'cover' }} alt="" />
                            </div>
                        </div>
                        <div class="col-lg-6 about-text py-5 wow fadeIn" data-wow-delay="0.5s">
                            <div class="p-lg-5 pe-lg-0">
                                <h3 class="text-primary">About Us</h3>
                                <p style={{ color: 'black' }}>SS Fire Engineers took shape as a dedicated organization to serve fire prevention and protection needs of the
                                    clients over since 2010. The aim of the organization is to provide the integrated, customized and sustainable
                                    turnkey solutions for Electronic Security, Fire Fighting systems, Fire Detection System, IBMS to our valued
                                    customers. Our goal is to keep facilities of our valued customers safe, protected, productive and delightful
                                    with our intelligent solutions and customer driven support of professional team</p>
                                <p style={{color:'black'}}><i class="fa fa-check-circle text-primary me-3"></i><span style={{ color: 'darkblue', fontWeight: 'bold' }}>Vision :-</span> Protect creations and safeguard environs of valued customers through innovative technologies,
                                    collaborations and strategic partnerships.</p>
                                <p style={{color:'black'}}><i class="fa fa-check-circle text-primary me-3"></i><span style={{ color: 'darkblue', fontWeight: 'bold' }}>MISSION :-</span> Customer oriented committed support and sustainable solutions creating safer and delightful
                                    workplaces for our valued customers.</p>
                                <Link to="/about"><a href="/about" class="btn btn-primary rounded-pill py-3 px-5 mt-3">Explore More</a></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- About End --> */}


            {/* <!-- Service Start --> */}
            <div class="container-xxl py-5">
                <div class="container">
                    <div class="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '900px' }}>
                        <h3 class="text-primary">Our Services</h3>
                        <h1 class="mb-4">We are pioneers in the fire detection & protection System, Fire Safety Assessments and Training.</h1>
                    </div>
                    <div class="row g-4">
                        <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.1s" >
                            <div class="service-item rounded overflow-hidden">
                                <img class="img-fluid" style={{ height: '300px' }} src="./img/engineer.jpg" alt="" />
                                <div class="position-relative p-4 pt-0">
                                    <div class="service-icon">
                                        <i class="fa fa-solar-panel fa-3x"></i>
                                    </div>
                                    <h5 class="mb-3">Engineering and Consultancy Services</h5>
                                    <Link to="/enginerringServices"><a class="small fw-medium" href="">Read More<i class="fa fa-arrow-right ms-2"></i></a></Link>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div class="service-item rounded overflow-hidden">
                                <img class="img-fluid" style={{ height: '300px' }} src="./img/fire_hydrant.jpg" alt="" />
                                <div class="position-relative p-4 pt-0">
                                    <div class="service-icon">
                                        <i class="fa fa-wind fa-3x"></i>
                                    </div>
                                    <h4 class="mb-3">Fire Hydrant System</h4>
                                    <Link to="/fireHydrant"><a class="small fw-medium" href="">Read More<i class="fa fa-arrow-right ms-2"></i></a></Link>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
                            <div class="service-item rounded overflow-hidden">
                                <img class="img-fluid" style={{ height: '300px' }} src="./img/fire-sprinkler-system.jpg" alt="" />
                                <div class="position-relative p-4 pt-0">
                                    <div class="service-icon">
                                        <i class="fa fa-lightbulb fa-3x"></i>
                                    </div>
                                    <h4 class="mb-3">Fire Sprinkler System</h4>
                                    <Link to="/firesprinkler"><a class="small fw-medium" href="">Read More<i class="fa fa-arrow-right ms-2"></i></a></Link>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
                            <div class="service-item rounded overflow-hidden">
                                <img class="img-fluid" style={{ height: '300px' }} src="./img/fire-alarm.jpg" alt="" />
                                <div class="position-relative p-4 pt-0">
                                    <div class="service-icon">
                                        <i class="fa fa-solar-panel fa-3x"></i>
                                    </div>
                                    <h4 class="mb-3">Fire Alarm and Detection System</h4>
                                    <Link to="/fireAlarm"><a class="small fw-medium" href="">Read More<i class="fa fa-arrow-right ms-2"></i></a></Link>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div class="service-item rounded overflow-hidden">
                                <img class="img-fluid" style={{ height: '300px' }} src="./img/public.jpg" alt="" />
                                <div class="position-relative p-4 pt-0">
                                    <div class="service-icon">
                                        <i class="fa fa-wind fa-3x"></i>
                                    </div>
                                    <h4 class="mb-3">Public Address System</h4>
                                    <Link to="/publicAddress"><a class="small fw-medium" href="">Read More<i class="fa fa-arrow-right ms-2"></i></a></Link>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
                            <div class="service-item rounded overflow-hidden">
                                <img class="img-fluid" style={{ height: '300px' }} src="./img/transformer.png" alt="" />
                                <div class="position-relative p-4 pt-0">
                                    <div class="service-icon">
                                        <i class="fa fa-lightbulb fa-3x"></i>
                                    </div>
                                    <h4 class="mb-3">Transformer Protection System</h4>
                                    <Link to="/transformerProtection"><a class="small fw-medium" href="">Read More<i class="fa fa-arrow-right ms-2"></i></a></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Service End --> */}


            {/* <!-- Feature Start --> */}
            {/* <div class="container-fluid bg-light overflow-hidden my-5 px-lg-0">
                <div class="container feature px-lg-0">
                    <div class="row g-0 mx-lg-0">
                        <div class="col-lg-6 feature-text py-5 wow fadeIn" data-wow-delay="0.1s">
                            <div class="p-lg-5 ps-lg-0">
                                <h6 class="text-primary">Why Choose Us!</h6>
                                <h1 class="mb-4">Complete Commercial & Residential Solar Systems</h1>
                                <p class="mb-4 pb-2">Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo erat amet</p>
                                <div class="row g-4">
                                    <div class="col-6">
                                        <div class="d-flex align-items-center">
                                            <div class="btn-lg-square bg-primary rounded-circle">
                                                <i class="fa fa-check text-white"></i>
                                            </div>
                                            <div class="ms-4">
                                                <p class="mb-0">Quality</p>
                                                <h5 class="mb-0">Services</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="d-flex align-items-center">
                                            <div class="btn-lg-square bg-primary rounded-circle">
                                                <i class="fa fa-user-check text-white"></i>
                                            </div>
                                            <div class="ms-4">
                                                <p class="mb-0">Expert</p>
                                                <h5 class="mb-0">Workers</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="d-flex align-items-center">
                                            <div class="btn-lg-square bg-primary rounded-circle">
                                                <i class="fa fa-drafting-compass text-white"></i>
                                            </div>
                                            <div class="ms-4">
                                                <p class="mb-0">Free</p>
                                                <h5 class="mb-0">Consultation</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="d-flex align-items-center">
                                            <div class="btn-lg-square bg-primary rounded-circle">
                                                <i class="fa fa-headphones text-white"></i>
                                            </div>
                                            <div class="ms-4">
                                                <p class="mb-0">Customer</p>
                                                <h5 class="mb-0">Support</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 pe-lg-0 wow fadeIn" data-wow-delay="0.5s" style={{ minweight: '400px' }}>
                            <div class="position-relative h-100">
                                <img class="position-absolute img-fluid w-100 h-100" src="img/feature.jpg" style={{ objectFit: 'cover' }} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <!-- Feature End --> */}


            {/* <!-- Projects Start --> */}
            {/* <div class="container-xxl py-5">
                <div class="container">
                    <div class="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px' }}>
                        <h6 class="text-primary">Our Projects</h6>
                        <h1 class="mb-4">Visit Our Latest Solar And Renewable Energy Projects</h1>
                    </div>
                    <div class="row mt-n2 wow fadeInUp" data-wow-delay="0.3s">
                        <div class="col-12 text-center">
                            <ul class="list-inline mb-5" id="portfolio-flters">
                                <li class="mx-2 active" data-filter="*">All</li>
                                <li class="mx-2" data-filter=".first">Solar Panels</li>
                                <li class="mx-2" data-filter=".second">Wind Turbines</li>
                                <li class="mx-2" data-filter=".third">Hydropower Plants</li>
                            </ul>
                        </div>
                    </div>
                    <div class="row g-4 portfolio-container wow fadeInUp" data-wow-delay="0.5s">
                        <div class="col-lg-4 col-md-6 portfolio-item first">
                            <div class="portfolio-img rounded overflow-hidden">
                                <img class="img-fluid" src="img/img-600x400-6.jpg" alt="" />
                                <div class="portfolio-btn">
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href="img/img-600x400-6.jpg" data-lightbox="portfolio"><i class="fa fa-eye"></i></a>
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href=""><i class="fa fa-link"></i></a>
                                </div>
                            </div>
                            <div class="pt-3">
                                <p class="text-primary mb-0">Solar Panels</p>
                                <hr class="text-primary w-25 my-2" />
                                <h5 class="lh-base">We Are pioneers of solar & renewable energy industry</h5>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 portfolio-item second">
                            <div class="portfolio-img rounded overflow-hidden">
                                <img class="img-fluid" src="img/img-600x400-5.jpg" alt="" />
                                <div class="portfolio-btn">
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href="img/img-600x400-5.jpg" data-lightbox="portfolio"><i class="fa fa-eye"></i></a>
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href=""><i class="fa fa-link"></i></a>
                                </div>
                            </div>
                            <div class="pt-3">
                                <p class="text-primary mb-0">Wind Turbines</p>
                                <hr class="text-primary w-25 my-2" />
                                <h5 class="lh-base">We Are pioneers of solar & renewable energy industry</h5>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 portfolio-item third">
                            <div class="portfolio-img rounded overflow-hidden">
                                <img class="img-fluid" src="img/img-600x400-4.jpg" alt="" />
                                <div class="portfolio-btn">
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href="img/img-600x400-4.jpg" data-lightbox="portfolio"><i class="fa fa-eye"></i></a>
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href=""><i class="fa fa-link"></i></a>
                                </div>
                            </div>
                            <div class="pt-3">
                                <p class="text-primary mb-0">Hydropower Plants</p>
                                <hr class="text-primary w-25 my-2" />
                                <h5 class="lh-base">We Are pioneers of solar & renewable energy industry</h5>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 portfolio-item first">
                            <div class="portfolio-img rounded overflow-hidden">
                                <img class="img-fluid" src="img/img-600x400-3.jpg" alt="" />
                                <div class="portfolio-btn">
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href="img/img-600x400-3.jpg" data-lightbox="portfolio"><i class="fa fa-eye"></i></a>
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href=""><i class="fa fa-link"></i></a>
                                </div>
                            </div>
                            <div class="pt-3">
                                <p class="text-primary mb-0">Solar Panels</p>
                                <hr class="text-primary w-25 my-2" />
                                <h5 class="lh-base">We Are pioneers of solar & renewable energy industry</h5>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 portfolio-item second">
                            <div class="portfolio-img rounded overflow-hidden">
                                <img class="img-fluid" src="img/img-600x400-2.jpg" alt="" />
                                <div class="portfolio-btn">
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href="img/img-600x400-2.jpg" data-lightbox="portfolio"><i class="fa fa-eye"></i></a>
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href=""><i class="fa fa-link"></i></a>
                                </div>
                            </div>
                            <div class="pt-3">
                                <p class="text-primary mb-0">Wind Turbines</p>
                                <hr class="text-primary w-25 my-2" />
                                <h5 class="lh-base">We Are pioneers of solar & renewable energy industry</h5>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 portfolio-item third">
                            <div class="portfolio-img rounded overflow-hidden">
                                <img class="img-fluid" src="img/img-600x400-1.jpg" alt="" />
                                <div class="portfolio-btn">
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href="img/img-600x400-1.jpg" data-lightbox="portfolio"><i class="fa fa-eye"></i></a>
                                    <a class="btn btn-lg-square btn-outline-light rounded-circle mx-1" href=""><i class="fa fa-link"></i></a>
                                </div>
                            </div>
                            <div class="pt-3">
                                <p class="text-primary mb-0">Hydropower Plants</p>
                                <hr class="text-primary w-25 my-2" />
                                <h5 class="lh-base">We Are pioneers of solar & renewable energy industry</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <!-- Projects End --> */}



            {/* <!-- Team Start --> */}
            {/* <div class="container-xxl py-5">
                <div class="container">
                    <div class="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{ maxwidth: '600px' }}>
                        <h6 class="text-primary">Team Member</h6>
                        <h1 class="mb-4">Experienced Team Members</h1>
                    </div>
                    <div class="row g-4">
                        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div class="team-item rounded overflow-hidden">
                                <div class="d-flex">
                                    <img class="img-fluid w-75" src="img/team-1.jpg" alt="" />
                                    <div class="team-social w-25">
                                        <a class="btn btn-lg-square btn-outline-primary rounded-circle mt-3" href=""><i class="fab fa-facebook-f"></i></a>
                                        <a class="btn btn-lg-square btn-outline-primary rounded-circle mt-3" href=""><i class="fab fa-twitter"></i></a>
                                        <a class="btn btn-lg-square btn-outline-primary rounded-circle mt-3" href=""><i class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div class="p-4">
                                    <h5>Full Name</h5>
                                    <span>Designation</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div class="team-item rounded overflow-hidden">
                                <div class="d-flex">
                                    <img class="img-fluid w-75" src="img/team-2.jpg" alt="" />
                                    <div class="team-social w-25">
                                        <a class="btn btn-lg-square btn-outline-primary rounded-circle mt-3" href=""><i class="fab fa-facebook-f"></i></a>
                                        <a class="btn btn-lg-square btn-outline-primary rounded-circle mt-3" href=""><i class="fab fa-twitter"></i></a>
                                        <a class="btn btn-lg-square btn-outline-primary rounded-circle mt-3" href=""><i class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div class="p-4">
                                    <h5>Full Name</h5>
                                    <span>Designation</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div class="team-item rounded overflow-hidden">
                                <div class="d-flex">
                                    <img class="img-fluid w-75" src="img/team-3.jpg" alt="" />
                                    <div class="team-social w-25">
                                        <a class="btn btn-lg-square btn-outline-primary rounded-circle mt-3" href=""><i class="fab fa-facebook-f"></i></a>
                                        <a class="btn btn-lg-square btn-outline-primary rounded-circle mt-3" href=""><i class="fab fa-twitter"></i></a>
                                        <a class="btn btn-lg-square btn-outline-primary rounded-circle mt-3" href=""><i class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div class="p-4">
                                    <h5>Full Name</h5>
                                    <span>Designation</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <!-- Team End --> */}





            {/* <!-- Footer Start --> */}
            <div class="container-fluid bg-dark text-body footer mt-5 pt-5 wow fadeIn" data-wow-delay="0.1s">
                <div class="container py-5">
                    <div class="row g-5">
                        <div class="col-lg-3 col-md-6">
                            <h5 class="text-white mb-4">Address</h5>
                            <p class="mb-2"><i class="fa fa-map-marker-alt me-3"></i>Office no-611, Vastu Elite Square,, Opposite Safron Landmark, Beed Bypass, Aurangabad-431010
                                <br/>Email-services@ssfireengineers.com
                                <br/>Phone:- 77981 21291</p>
                            <div class="d-flex pt-2">
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-facebook-f"></i></a>
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-youtube"></i></a>
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <h5 class="text-white mb-4">Quick Links</h5>
                            <a class="btn btn-link" href="/">Home</a>
                            <a class="btn btn-link" href="/about">About Us</a>
                            <a class="btn btn-link" href="/contact">Contact Us</a>
                        </div>

                        <div class="col-lg-3 col-md-6">
                            <h5 class="text-white mb-4">Newsletter</h5>
                            <div class="position-relative mx-auto" style={{ maxwidth: '400px' }}>
                                <input class="form-control border-0 w-100 py-3 ps-4 pe-5" type="text" placeholder="Your email" />
                                <button type="button" class="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">SignUp</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="copyright">
                        <div class="row">
                            <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                                &copy; <a href="#">SS FIRE ENGINEERS</a>, All Right Reserved.
                            </div>
                            <div class="col-md-6 text-center text-md-end">
                                {/* This template is free as long as you keep the footer author’s credit link/attribution link/backlink. If you'd like to use the template without the footer author’s credit link/attribution link/backlink, you can purchase the Credit Removal License from "https://htmlcodex.com/credit-removal". Thank you for your support.  */}
                                Designed By <a href="#">BFI</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
}

export default Index;
